import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { MailModule } from 'src/mail/mail.module';
import { EcommerceNotificationsService } from './ecommerce-notifications.service';

@Module({
  imports: [PrismaModule, MailModule],
  providers: [EcommerceNotificationsService],
  exports: [EcommerceNotificationsService],
})
export class EcommerceNotificationsModule {}
